import React, { useState } from 'react';
import PortfolioRegForm from '../components/PortfolioRegForm';
import Modal from '../components/Modal';
import LoginForm from '../components/LoginForm';

const Passionate = () => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

  const onCreate = () => setIsCreateModalOpen(true);
  const onLogin  = () => setIsLoginModalOpen(true);

  return (
    <div style={containerStyle}>
      <h1>Showcase. Stand out Be Seen</h1>
      <p style={{ fontSize: "18px", maxWidth: "600px", margin: "auto" }}>
        Stand out with a professional record of your work
      </p>

      <div style={buttonContainer}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}>
            <p style={{ fontSize: '18px', margin: 0 }}>New Here?</p>
            <button onClick={onCreate} style={buttonStyle}>
              Create Portfolio
            </button>
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}>
            <p style={{ fontSize: '18px', margin: 0 }}>Already Created?</p>
            <button onClick={onLogin} style={buttonStyle}>
              Visit Portfolio
            </button>
          </div>
        </div>
      </div>

      {/* — Create Portfolio sub‑modal — */}
      <Modal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
      >
        <PortfolioRegForm closeModal={() => setIsCreateModalOpen(false)} />
      </Modal>

      {/* — Login sub‑modal — */}
      <Modal
        isOpen={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
      >
        <LoginForm onLoginSuccess={() => setIsLoginModalOpen(false)} />
      </Modal>
    </div>
  );
};

const containerStyle = {
  padding: "40px 20px",
  textAlign: "center",
};

const buttonContainer = {
  marginTop: "30px",
  display: "flex",
  justifyContent: "center",
  gap: "20px",
  flexWrap: "wrap",
};

const buttonStyle = {
  padding: "12px 24px",
  fontSize: "16px",
  cursor: "pointer",
  backgroundColor: "#007bff",
  color: "white",
  border: "none",
  borderRadius: "8px",
};

export default Passionate;
